export const PAGE_PATHS = {
	vehicleProjects: '/vehicleProjects',
	regulations: '/regulations',
	requirements: '/requirements',
	simulations: '/simulations',
};
